import { gql } from "@apollo/client";

export const ADD_FAVORITE = gql`
  mutation AddFavoriteMutation($input: AddFavoriteInput!) {
    addFavorite(input: $input) {
      ok
      error
      id
    }
  }
`;

export const REMOVE_FAVORITE = gql`
  mutation RemoveFavoriteMutation($id: Int!) {
    removeFavorite(id: $id) {
      ok
      error
    }
  }
`;

export const FAVORITES = gql`
  query FavoritesQuery($where: FavoriteProductsFiltersInput) {
    favorites(where: $where) {
      ok
      error
      results {
        id
        userId
        productId
        createdAt
        updatedAt
        product {
          id
          name
          url
          imgUrl
          reference
          lastQuantity
          lastPrice
          priceOnly
        }

        user {
          id
          email
        }
      }
    }
  }
`;

export const FAVORITES_SIMPLE = gql`
  query FavoritesSimpleQuery($where: FavoriteProductsFiltersInput) {
    favorites(where: $where) {
      ok
      error
      results {
        id
        productId
      }
    }
  }
`;
